import { combineReducers, createStore, applyMiddleware } from 'redux';
import reduxThunk from 'redux-thunk';
import languageSelectorReducer from './languageSelectorReducer';
import configurationReducer from './configurationReducer';
import languageMenuReducer from './languageMenuReducer';
import screenReducer from './screenReducer';
import filterReducer from './filterReducer';
import heightReducer from './heightReducer';
import consentSwitchReducer from './consentSwitchReducer';
import objectConsentSwitchReducer from './objectConsentSwitchReducer';

const reducers = combineReducers({
    currentHeight: heightReducer,
    currentFilter: filterReducer,
    currentLanguage: languageSelectorReducer,
    currentScreen: screenReducer,
    configuration: configurationReducer,
    isLanguageMenuOpen: languageMenuReducer,
    consentSwitchValue: consentSwitchReducer,
    objectConsentSwitchValue: objectConsentSwitchReducer
});

export default createStore(reducers, applyMiddleware(reduxThunk));